import { Box } from "@mui/material";
import stylesHeader from "./../../styles/Atoms/Header/Header";

function BoxHeader(props) {
  const { color, children, sx } = props;

  return (
    <Box
      sx={{
        ...stylesHeader.contentHeader(color),
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

export default BoxHeader;
